import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";
import type { PaginatedMeta } from "./audience_helper";
import type { Campaign } from "./campaigns_helper";

const apiBase = config.api.API_URL;

export type Template = {
  id: number;
  name: string;
  html_body: string;
  editor_design: Record<string, unknown> | null;
  created_at?: string;
  updated_at?: string;
};

type TemplatesListResponse = ApiSuccess<Template[]> & {
  meta: PaginatedMeta;
  links?: unknown;
};

export type TemplatePayload = {
  name: string;
  html_body: string;
  editor_design?: Record<string, unknown> | null;
};

export const getTemplates = (params?: {
  search?: string;
  page?: number;
  per_page?: number;
}): Promise<TemplatesListResponse> => {
  return axios.get(apiBase + "/templates", { params });
};

export const getTemplate = (id: number): Promise<ApiSuccess<Template>> => {
  return axios.get(apiBase + "/templates/" + id);
};

export const createTemplate = (
  payload: TemplatePayload
): Promise<ApiSuccess<Template>> => {
  return axios.post(apiBase + "/templates", payload);
};

export const updateTemplate = (
  id: number,
  payload: Partial<TemplatePayload>
): Promise<ApiSuccess<Template>> => {
  return axios.patch(apiBase + "/templates/" + id, payload);
};

export const deleteTemplate = (id: number): Promise<ApiSuccess<null>> => {
  return axios.delete(apiBase + "/templates/" + id);
};

export const createCampaignFromTemplate = (
  id: number,
  payload?: { name?: string; subject?: string }
): Promise<ApiSuccess<Campaign>> => {
  return axios.post(apiBase + "/templates/" + id + "/create-campaign", payload || {});
};
